module.exports = __webpack_public_path__ + "img/11.c020bc72.jpg";